"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentSettingsCompatSettingDestination = exports.DocumentSettingsCompatDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var compat_settings_1 = require("../../../../core/model/compat-settings");
var document_model_1 = require("../../../../core/model/document-model");
var destination_1 = require("../destination");
var DocumentSettingsCompatDestination = (function (_super) {
    tslib_1.__extends(DocumentSettingsCompatDestination, _super);
    function DocumentSettingsCompatDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DocumentSettingsCompatDestination.prototype, "elementHandlerTable", {
        get: function () {
            return DocumentSettingsCompatDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    DocumentSettingsCompatDestination.handlerTable = new map_creator_1.MapCreator()
        .add('compatSetting', function (data) { return new DocumentSettingsCompatSettingDestination(data); })
        .get();
    return DocumentSettingsCompatDestination;
}(destination_1.ElementDestination));
exports.DocumentSettingsCompatDestination = DocumentSettingsCompatDestination;
var DocumentSettingsCompatSettingDestination = (function (_super) {
    tslib_1.__extends(DocumentSettingsCompatSettingDestination, _super);
    function DocumentSettingsCompatSettingDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentSettingsCompatSettingDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var compatSettings;
            return tslib_1.__generator(this, function (_a) {
                compatSettings = new compat_settings_1.CompatSettings();
                compatSettings.name = this.data.readerHelper.readAttribute(reader, 'name');
                compatSettings.uri = this.data.readerHelper.readAttribute(reader, 'uri');
                compatSettings.value = this.data.readerHelper.readAttribute(reader, 'val');
                this.data.documentModel.compatSettings.push(compatSettings);
                this.processSetting(reader, compatSettings);
                return [2];
            });
        });
    };
    DocumentSettingsCompatSettingDestination.prototype.processSetting = function (reader, prop) {
        if (prop.name == "compatibilityMode")
            this.data.documentModel.compatibilitySettings.compatibilityMode = this.data.readerHelper.getWpSTIntegerValue(reader, "val", document_model_1.CompatibilityMode.Word2007);
    };
    return DocumentSettingsCompatSettingDestination;
}(destination_1.LeafElementDestination));
exports.DocumentSettingsCompatSettingDestination = DocumentSettingsCompatSettingDestination;
